import React, {useState, useEffect } from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi"; 

const OutcomeinfologEdit = ()=>{
     const [betid, setBetid ] = useState('');
     const [outcome, setOutcome ] = useState('');
     const [payout, setPayout ] = useState('');
     const [outcomedate, setOutcomedate ] = useState('');
     const [winnings, setWinnings ] = useState('');
     const [withholdingtax, setWithholdingtax ] = useState('');
     const [walletbalanceoutcome, setWalletbalanceoutcome ] = useState('');
     const [sentToKra, setSentToKra ] = useState('');
    const [redirect, setRedirect] = useState(false); 

    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`outcomeInfoLog/${id}`);
                 setBetid(data.betid);
                 setOutcome(data.outcome);
                 setPayout(data.payout);
                 setOutcomedate(data.outcomedate);
                 setWinnings(data.winnings);
                 setWithholdingtax(data.withholdingTax);
                 setWalletbalanceoutcome(data.walletBalanceOutcome);
                 setSentToKra(data.sent_to_kra);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`outcomeInfoLog/${id}`, {
            betid,
            outcome,
            payout,
            outcomedate,
            winnings,
            withholdingtax,
            walletbalanceoutcome,
            sentToKra,
        });
        console.log(data);
        setRedirect(true);
    };
    
    if(redirect){
         return <Navigate to={'/outcomeinfologs'} />
    }
    return (
        <Wrapper pageTitle={'Edit Outcomeinfolog'}>
            <InnerNav createLink={'/outcomeinfologCreate'} listLink={'/outcomeinfologs'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Betid </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Betid" value={betid}
                        onChange = {e => setBetid(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Outcome </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Outcome" value={outcome}
                        onChange = {e => setOutcome(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Payout </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Payout" value={payout}
                        onChange = {e => setPayout(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Outcomedate </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Outcomedate" value={outcomedate}
                        onChange = {e => setOutcomedate(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Winnings </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Winnings" value={winnings}
                        onChange = {e => setWinnings(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Withholdingtax </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Withholdingtax" value={withholdingtax}
                        onChange = {e => setWithholdingtax(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Walletbalanceoutcome </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Walletbalanceoutcome" value={walletbalanceoutcome}
                        onChange = {e => setWalletbalanceoutcome(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">SentToKra </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="SentToKra" value={sentToKra}
                        onChange = {e => setSentToKra(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default OutcomeinfologEdit;